import Model from '@/models/Model'

export default class HrPreviredEmployeeType extends Model {
    resource() {
        return 'hr_previred_employee_type'
    }
}